import React from "react";
import PropTypes from "prop-types";
const HighchartsReact = window.HighchartsReact;
import {
  COLUMN_COLOR,
  odaTooltipOptions,
  NUM_OF_YEARS_TO_SHOW,
  DONUT_COLORS
} from "../chartOptions";

const latestYear = data => data[data.length -1].year;

const mapDonorDonutValues = data => data.map(d => ({ y: d.value, name: d.name }));

const mapAnnualDisbursementValues = data => {
  const fromYear = data[data.length - NUM_OF_YEARS_TO_SHOW].year;
  const endYear = data[data.length - 1].year;
  const dataToShow = data.filter(d => d.year >= fromYear && d.year <= endYear);
  return dataToShow.map(d => ({ y: d.value, name: d.year }));
};

const mapAnnualDisbursementYears = data => {
  const fromYear = data[data.length - NUM_OF_YEARS_TO_SHOW].year;
  const endYear = data[data.length - 1].year;
  const yearsToShow = data.filter(d => d.year >= fromYear && d.year <= endYear);
  return yearsToShow.map(d => d.year);
};

const donorDonut = data => ({
  chart: {
    type: "pie",
    height: 300
  },
  colors: DONUT_COLORS,
  credits: {
    enabled: false,
  },
  title: {
    text: `<div>Breakdown by donor<br /> (Total disbursements ${latestYear(data.annual_total_disbursement) - NUM_OF_YEARS_TO_SHOW + 1}-${latestYear(data.annual_total_disbursement)})</div>`,
    style: {
      fontWeight: "bold",
      fontSize: "1.4rem",
      textAlign: "center"
    },
    useHTML: true
  },
  subtitle: {
    text: `Total<br/>
           $${data.total_disbursement_in_num_years_period.toFixed(1)} million`,
    floating: true,
    style: {
      color: "#000",
      textAlign: "center",
    },
    useHTML: true,
    verticalAlign: "middle"
  },
  exporting: {
    enabled: false
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    pie: {
      innerSize: 100,
      dataLabels: {
        enabled: false
      }
    }
  },
  tooltip: {
    ...odaTooltipOptions,
    valueSuffix: "million"
  },
  series: [{
    data: mapDonorDonutValues(data.breakdown_by_donor)
  }]
});

const annualDisbursement = data => {
  const fromYear = data[data.length - NUM_OF_YEARS_TO_SHOW].year;
  const endYear = data[data.length - 1].year;
  return ({
    chart: {
      type: "column",
      height: 300,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: `Annual total disbursements (${fromYear} - ${endYear})`,
      style: {
        fontWeight: "bold",
        fontSize: "1.4rem"
      }
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    tooltip: {
      ...odaTooltipOptions,
      valueSuffix: "million"
    },
    xAxis: {
      categories: mapAnnualDisbursementYears(data),
      tickLength: 0
    },
    yAxis: {
      title: {
        text: "$ million"
      }
    },
    series: [{
      data: mapAnnualDisbursementValues(data),
      color: COLUMN_COLOR
    }],
  });
};

const CountryODAChart = ({ highcharts, data }) => (
  <div>
    <div className="oda-chart-wrapper">
      <HighchartsReact
        highcharts={highcharts}
        constructorType={"chart"}
        options={donorDonut(data)}
      />
    </div>
    <div className="oda-chart-wrapper">
      <HighchartsReact
        highcharts={highcharts}
        constructorType={"chart"}
        options={annualDisbursement(data.annual_total_disbursement)}
      />
    </div>
  </div>
);

export default CountryODAChart;

CountryODAChart.propTypes = {
  data: PropTypes.shape({}).isRequired,
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }),
};
